function bbAfterAddToCart() {
  console.log('bbAfterAddToCart override function');
}
document.addEventListener('DOMContentLoaded', function () {
  document.addEventListener('change', function () {
    if (event.target.matches('.product-bundle-builder__suggestion select')) {
      let e = event.target.value;
      if (e) {
        setTimeout(() => {
          document
            .querySelectorAll('.product-bundle-builder__suggestion select option')
            .forEach(function (t) {
              t.value == e && t.setAttribute('selected', 'selected');
            });
        }, 200);
        let t =
          window.location.protocol +
          '//' +
          window.location.host +
          window.location.pathname +
          '?bundle=' +
          e;
        window.history.pushState({ path: t }, '', t);
      } else {
        let e = window.location.protocol + '//' + window.location.host + window.location.pathname;
        window.history.pushState({ path: e }, '', e);
      }
    }
  });
  let e = new URLSearchParams(window.location.search).get('bundle');
  setTimeout(() => {
    let t = document.querySelector(
      '.product-bundle-builder__suggestion select option[value="' + e + '"]'
    );
    if (t) {
      t.setAttribute('selected', 'selected'), (t.selected = !0);
      let e = t.closest('select'),
        o = new Event('change', { bubbles: !0 });
      e.dispatchEvent(o);
    }
  }, 2e3),
    setTimeout(() => {
      let t = document.querySelector(
        '.product-bundle-builder__suggestion select option[value="' + e + '"]'
      );
      t && (t.setAttribute('selected', 'selected'), (t.selected = !0));
    }, 3e3);
});
